import { PopoverOrigin, Stack, Theme, useMediaQuery } from '@mui/material';
// import { useAuth } from '@schooly/components/authentication';
import React, { FC } from 'react';

import { DropdownCommentsItem } from '../../DropdownComments/DropdownComments';
import { Comment, CommentProps } from './Comment';
import { CommentLayout } from './CommentLayout';

export interface CommentsProps {
  comments?: DropdownCommentsItem[];
  maxRows?: number;
  showInput?: boolean;
  canEditOwn?: boolean;
  canEditOther?: boolean;
  showAllComments?: boolean;
  onBlur?: (text: string, relationId?: string) => void;
  placement?: PopoverOrigin;
  tableView?: boolean;
  plainCommentsListOnly?: boolean;
  autoFocusOnEdit?: boolean;
  saveOnEnterPress?: boolean;
  currentStaff?: CommentProps['currentStaff'];
  placeholder?: string;
}

export const Comments: FC<CommentsProps> = ({
  comments,
  maxRows,
  showInput,
  canEditOwn,
  canEditOther,
  onBlur,
  placement,
  tableView,
  plainCommentsListOnly,
  autoFocusOnEdit,
  saveOnEnterPress,
  currentStaff,
  placeholder,
}) => {
  const belowXlScreenWidth = useMediaQuery((theme: Theme) => theme.breakpoints.down('xl'));

  if (plainCommentsListOnly) {
    return (
      <>
        {comments?.map((comment) => (
          <Stack
            key={comment.id}
            sx={(theme) => ({
              '&:not(:last-child)': {
                borderBottom: theme.mixins.borderValue(),
              },
            })}
          >
            <Comment
              canEditOwn={canEditOwn}
              canEditOther={canEditOther}
              comment={comment}
              maxRows={maxRows}
              onBlur={onBlur}
              plainCommentOnly
              currentStaff={currentStaff}
              placeholder={placeholder}
            />
          </Stack>
        ))}

        {showInput && (
          <Comment
            plainCommentOnly
            onBlur={onBlur}
            maxRows={maxRows}
            autoFocus
            currentStaff={currentStaff}
            placeholder={placeholder}
          />
        )}
      </>
    );
  }

  return (
    <CommentLayout placement={placement} tableView={tableView}>
      {comments?.map((comment) => (
        // biome-ignore lint/correctness/useJsxKeyInIterable: Legacy code
        <Stack
          sx={(theme) => ({
            '&:not(:last-child)': {
              borderBottom: theme.mixins.borderValue(),
            },
          })}
        >
          <Comment
            canEditOwn={canEditOwn}
            canEditOther={canEditOther}
            comment={comment}
            key={comment.id}
            maxRows={maxRows}
            onBlur={onBlur}
            autoFocus={autoFocusOnEdit}
            saveOnEnterPress={saveOnEnterPress}
            currentStaff={currentStaff}
            placeholder={placeholder}
          />
        </Stack>
      ))}

      {showInput && (
        <Comment
          onBlur={onBlur}
          maxRows={maxRows}
          // biome-ignore lint/complexity/noUselessTernary: Legacy code
          autoFocus={belowXlScreenWidth ? false : true}
          saveOnEnterPress={saveOnEnterPress}
          currentStaff={currentStaff}
          placeholder={placeholder}
        />
      )}
    </CommentLayout>
  );
};
